var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.dispositivo.apkversion.indexOf('2.66') === 0)?_c('mensagem-somente-pro-teste'):_vm._e(),_c('Chat',{attrs:{"messenger":"whatsapp"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }